export const environment = {
    production: false,
    urlAPI: 'https://apicalculadoraseat.easymarketingred.es/api/',
    urlServer: 'https://apicalculadoraseat.easymarketingred.es/',
    urlCita: 'https://www.seat.es'
  };
